var exports = {
  "kL": "TextToSpeech.module__container___Vmx0Wl",
  "$J": "TextToSpeech.module__linkButton___Vmx0Wl",
  "h3": "TextToSpeech.module__helperCallout___Vmx0Wl",
  "E$": "TextToSpeech.module__helperIcon___Vmx0Wl",
  "cy": "TextToSpeech.module__helperText___Vmx0Wl",
  "Cc": "TextToSpeech.module__narrationSection___Vmx0Wl",
  "qE": "TextToSpeech.module__narrationHeader___Vmx0Wl",
  "hC": "TextToSpeech.module__narrationTitle___Vmx0Wl",
  "Hb": "TextToSpeech.module__narrationDescription___Vmx0Wl",
};

module.exports = exports;
